import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { BaseInputDiscount } from "..";
import { useCart, useSession } from "@hooks";

type InputGiftProps = {
  placeholder: string;
  btnSubmitText?: string;
  onSuccess: (str: string, code?: string) => void;
  onError: (str: string, code?: string) => void;
};

const languagesVarsCodes = [
  "LANG_neobooking_discount_successfully_applied", //Réduction appliquée !
  "LANG_neobooking_discount_applying_in_progress", //Application de la réduction en cours
];

const InputGift: React.FC<InputGiftProps> = ({
  placeholder,
  btnSubmitText = "OK",
  onError,
  onSuccess,
}) => {
  /* Hooks */
  const { addGiftCode } = useCart();
  const { getLanguageVarValue } = useSession();

  /* State */
  const [giftCode, setGiftCode] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmitGiftCode = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const toastAdd = toast.loading(
      `${getLanguageVarValue(
        "LANG_neobooking_discount_applying_in_progress"
      )}...`
    );
    if (!isEmpty(giftCode)) {
      addGiftCode(giftCode, (err) => {
        if (err) {
          toast.error(err.message, {
            id: toastAdd,
          });
          onError(err.message, giftCode);
          onSuccess("");
        } else {
          toast.success(
            getLanguageVarValue(
              "LANG_neobooking_discount_successfully_applied"
            ),
            {
              id: toastAdd,
            }
          );
          onError("");
          onSuccess(
            getLanguageVarValue(
              "LANG_neobooking_discount_successfully_applied"
            ),
            giftCode
          );
        }
        setIsSubmitting(false);
      });
    }
  };

  return (
    <BaseInputDiscount
      value={giftCode}
      setValue={setGiftCode}
      onSubmit={handleSubmitGiftCode}
      isSubmitting={isSubmitting}
      placeholder={placeholder}
      btnSubmitText={btnSubmitText}
      onFormChange={() => onError("")}
    />
  );
};

InputGift.propTypes = {
  //
};

export default InputGift;
